export default () => ({
  status: {
    error: '',
  },
  garages: [],
  garageSearchResults: [],
  tireCodes: [],
});
